import { Row, Col, Image, Space, Typography } from "antd";
import GroupKind from "~/components/groups/GroupKind";
import GroupMemberCount from "~/components/groups/GroupMemberCount";
import GroupMark from "~/components/groups/GroupMark";

const { Title } = Typography;

const GroupInfoSmall = ({ group, className }: any) => {
  const hasMark = group.featured || group.paid || group.recent;

  return (
    <div className={`group-sm-wrapper ${className}`}>
      <Row
        align="middle"
        wrap={false}
      >
        <Col
          flex="80px"
          style={{ textAlign: "left" }}
        >
          <Image
            src={group.logo.url}
            preview={false}
            alt={group.name}
            width={70}
            height={70}
            style={{ borderRadius: "8px" }}
          />
        </Col>
        <Col flex="auto">
          <Space
            direction="vertical"
            size={7}
            style={{ display: "flex" }}
          >
            <Row wrap={false}>
              <Col flex="auto">
                <Title
                  level={5}
                  style={{ marginBottom: 0 }}
                  title={group.name}
                  ellipsis
                >
                  {group.name}
                </Title>
              </Col>
              {hasMark && (
                <Col flex="60px">
                  <GroupMark group={group} />
                </Col>
              )}
            </Row>
            <Row gutter={10}>
              <Col>
                <GroupKind group={group} />
              </Col>
              <Col>
                <GroupMemberCount group={group} />
              </Col>
            </Row>
          </Space>
        </Col>
      </Row>
    </div>
  );
};
export default GroupInfoSmall;
